"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcInvoicePayments = void 0;
const UcInvoicePayments_yaml_component_1 = __importDefault(require("./UcInvoicePayments.yaml?component"));
exports.UcInvoicePayments = UcInvoicePayments_yaml_component_1.default;
